import { configureStore } from '@reduxjs/toolkit'
import mapReducer from './mapSlice'
import gridVisibilityReducer from './gridVisibilitySlice'
import selectedLayerReducer from './selectedLayerSlice'
import colorsReducer from './colorsSlice'
import mapStyleReducer from './mapStyleSlice'
import layersReducer from '../redux/pixelLayersSlice'

const store = configureStore({
  reducer: {
    map: mapReducer,
    gridVisibility: gridVisibilityReducer,
    selectedLayer: selectedLayerReducer,
    layers: layersReducer,
    colors: colorsReducer,
    mapStyle: mapStyleReducer
  }
})

export default store
